import React, { useEffect, useState } from "react";

import Header from "./header";
import Footer from "./footer";

import { dataListsType, videoDataListsType } from "../shared/type";
import { DataLists } from "../dataLists/DataLists";
import TrendingNow from "./trendingNow";
import AIPowered from "./aiPowered";
import ParagraphTitle from "./paragraphTitle";
import VideoPlay from "./videoPlay";
import CardLeftRight from "./cardleftright";
import VideoSearch from "./videosearch";
import { videoDataLists } from "../dataLists/videoDataLists";

import AdPage from "./AdPage";

const PCTemplate: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [latestPostsData, setLatestPostsData] = useState<dataListsType[]>([]);
  const [featuredpostsFirstData, setFeaturedpostsFirstData] = useState<
    videoDataListsType[]
  >([]);
  const [featuredpostsSecondData, setFeaturedpostsSecondData] = useState<
    dataListsType[]
  >([]);
  const [fixedArticleDataLists, setFixedArticleDataLists] = useState<
    dataListsType[]
  >([]);
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    if (windowWidth < 1170) {
      setIsShow(true);
    }
  }, [windowWidth]);

  const getLatestPostsData = () => {
    const data = [...DataLists].slice(-5).sort(() => 0.5 - Math.random());
    // const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    // const data = randomData.slice(0, 4);
    setLatestPostsData(data.slice(0, 4));
  };
  const targetIds = [10, 23, 32, 2];
  const getFixedArticleDataLists = () => {
    const data = [...DataLists].filter((item) =>
      targetIds.includes(item.id as number),
    );
    setFixedArticleDataLists(data.sort(() => 0.5 - Math.random()));
  };

  const getFeaturedpostsFirstData = () => {
    const data = [...videoDataLists].sort(() => 0.5 - Math.random());
    setFeaturedpostsFirstData(data.slice(0, 10));
  };
  const getFeaturedpostsSecondData = () => {
    // const data = DataLists.slice(51, 53);
    // const data = [...DataLists].sort(() => 0.5 - Math.random());
    const data = [...DataLists].slice(-25).sort(() => 0.5 - Math.random());
    setFeaturedpostsSecondData(data.slice(0, 6));
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getLatestPostsData();
    getFeaturedpostsFirstData();
    getFeaturedpostsSecondData();
    getFixedArticleDataLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // -------------------------- aq-x short player start --------------------------
  // useEffect(() => {
  //   const script = document.createElement("script");

  //   script.src = "https://aq-x.com/embed/player/iframe-embed.js";
  //   script.async = true;
  //   script.dataset.container = "aqx-short-player-slot";
  //   script.dataset.embedBase = "https://aq-x.com";
  //   script.dataset.playBase = "https://aq-x.com";
  //   script.dataset.limit = "10";
  //   script.dataset.maxWidth = "420";
  //   script.dataset.maxHeight = "820";

  //   document.body.appendChild(script);

  //   return () => {
  //     script.remove();
  //     document.getElementById("aqx-short-player-slot")?.replaceChildren();
  //   };
  // }, []);
  // -------------------------- aq-x short player end --------------------------

  return (
    <>
      <Header />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>
      <section className="lg:pb-[2px] pb-[1px]">
        <div className="relative bg-gray-300">
          {/* video */}
          <div className="pt-[120%] sm:pt-[80%] md:pt-[74%] lg:pt-[64%] xl:pt-[49%] w-full h-full">
            <video
              src="https://creative.cdn.apm.any-digital.com/h5/exploreAsia/video/Asia%20Video.mp4"
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full h-full object-cover absolute top-0 left-0"
            ></video>
          </div>
          {/* content */}
          <div className="w-full h-full absolute top-0 left-0 bg-black bg-opacity-0">
            <div
              className={`w-full h-full flex items-center justify-center xl:gap-x-32 xl:px-0 ${
                windowWidth < 1170 ? "px-8 gap-x-8" : "px-32 gap-x-10"
              }`}
            >
              {/*  AI-Powered searchbar */}
              <AIPowered />

              {/* Trending Now */}
              <TrendingNow
                latestPostsData={latestPostsData}
                className="hidden lg:block"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="block lg:hidden">
        <AdPage id_name="ad_sample_1" />
      </div>

      <section className="lg:hidden bg-[#181818] mb-[1px] flex justify-center items-center w-full h-full px-8 md:py-[100px] py-[60px]">
        <TrendingNow
          latestPostsData={latestPostsData}
          className="block lg:hidden"
          isShow={isShow}
        />
      </section>

      {/* -------------------------- aq-x short player start -------------------------- */}
      {/* <div
        className="life wid1530 mt20"
        style={{ width: "100%", maxWidth: "420px", margin: "20px auto" }}
      >
        <div id="aqx-short-player-slot" />
      </div> */}
      {/* -------------------------- aq-x short player end -------------------------- */}

      <AdPage id_name="ad_sample_2" />

      <section className="pb-[100px] bg-[#181818]">
        <ParagraphTitle title="Explore Clips" color="#f8f4ee" />
        <VideoSearch />

        <div className="flex-col md:flex-row flex w-full justify-between gap-y-8 px-8 2xl:px-40 xl:px-24 lg:px-14">
          <VideoPlay props={featuredpostsFirstData} />
        </div>
      </section>

      <AdPage id_name="ad_sample_3" />

      <section className="pb-[100px]">
        <ParagraphTitle title="Spotlight" color="#201d1d" />

        <div className="flex-col md:flex-row flex w-full justify-between gap-y-8 px-8 2xl:px-40 xl:px-24 lg:px-14 mb-8">
          <CardLeftRight props={fixedArticleDataLists} />
        </div>
        <div className="flex-col md:flex-row flex w-full justify-between gap-y-8 px-8 2xl:px-40 xl:px-24 lg:px-14">
          <CardLeftRight props={featuredpostsSecondData} />
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PCTemplate;
